import Cookies from 'js-cookie';
import ready from './app/ready';
import './app/cookies-msg';

function getQueryString() {
	return window.location.search.substring(1);
}

/**
 * Decode the url encoded parameter val
 * @param {string} encodedString 
 * @returns {string}
 */
function decode(encodedString) {
	const replacedPlusses = encodedString.replace(/\+/g, ' ');
	return decodeURIComponent(replacedPlusses);
}

/**
 * Get the parameter object from the query string
 * @param {string} queryString 
 * @returns {Object}
 */
function getParams(queryString) {
	const regexp = /([^&=]+)=?([^&]*)/g;
	const params = {};
	let matches;
	while ((matches = regexp.exec(queryString))) {
		params[matches[1]] = decode(matches[2]);
	}
	return params;
}

/**
 * 
 * @param {string} key 
 * @param {Object} params 
 * @returns {string}
 */
function getProperty(key, params) {
	let val = '';
	if (typeof params[key] !== 'undefined') {
		val = params[key];
	}
	return val;
}

ready.then(() => {
	const params = getParams(getQueryString());
	Cookies.set('utm_source', getProperty('utm_source', params), { path: '/' });
	Cookies.set('utm_campaign', getProperty('utm_campaign', params), { path: '/' });
	Cookies.set('utm_content', getProperty('utm_content', params), { path: '/' });
	Cookies.set('utm_medium', getProperty('utm_medium', params), { path: '/' });
});
